import { Button, IconButton, CircularProgress, ButtonProps } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import { Auth } from '@edge/spark/io-aws'
import { clearDialog } from '../dialog.store'

// TEXT BUTTONS

export const LOGOUT: React.VFC<ButtonProps> = (props: ButtonProps) => {
    const onClick = () => {
        clearDialog()
        console.debug('KnownActions LOGOUT: Signing out...')
        Auth.signOut()
    }

    return (
        <Button color="inherit" size="small" onClick={onClick} {...props}>
            LOGOUT
        </Button>
    )
}

export const REFRESH: React.VFC<ButtonProps> = (props: ButtonProps) => {
    const onClick = () => {
        clearDialog()
        window.history.go(0)
    }

    return (
        <Button color="inherit" size="small" onClick={onClick} {...props}>
            REFRESH
        </Button>
    )
}

const UPDATE: React.VFC<ButtonProps> = (props: ButtonProps) => {
    return (
        <Button color="inherit" size="small" disabled {...props}>
            UPDATE
        </Button>
    )
}

const OK: React.VFC<ButtonProps> = (props: ButtonProps) => {
    const onClick = () => clearDialog()

    return (
        <Button color="inherit" size="small" onClick={onClick} {...props}>
            OK
        </Button>
    )
}

// ICON BUTTONS

export const CLOSE: React.FC = () => {
    const onClick = () => clearDialog()

    return (
        <IconButton color="inherit" size="small" onClick={onClick}>
            <CloseIcon fontSize="small" />
        </IconButton>
    )
}

export const SPINNER: React.FC = () => {
    const onClick = () => clearDialog()

    return (
        <Button size="small" onClick={onClick}>
            <CircularProgress size={16} />
        </Button>
    )
}

export const KnownActions = { REFRESH, LOGOUT, UPDATE, SPINNER, CLOSE, OK }
